// Backend access for the camera measurement flow. The vision python (run by
// M521) writes a `measurement` object into abstraction.rownd and a fixed capture
// image; both are exposed read-only by the backend.
import { API_BASE } from '@/types/machine.types';

// Fixed capture image endpoint. Callers append `?t=<Date.now()>` to bust the
// browser cache so a fresh measurement's image is always refetched.
export const CAMERA_IMAGE_URL = `${API_BASE}/camera/image`;

// I/J/K = width/length/height, in mm, as written by the vision python. K
// (height) is optional — the vision output may omit it.
export interface Measurement {
  I: number;
  J: number;
  K?: number;
}

/** Read the latest camera measurement, or null when M521 hasn't produced one. */
export async function fetchMeasurement(): Promise<Measurement | null> {
  const res = await fetch(`${API_BASE}/measurement`);
  if (!res.ok) throw new Error(`GET /measurement ${res.status.toString()}`);
  const data = (await res.json()) as { measurement: Measurement | null };
  return data.measurement ?? null;
}
